import type { ProductCategory, ProductUpdate, UpdateCategory } from '@product-updates/shared-types';

export interface Badge {
  category: ProductCategory | UpdateCategory;
  type: 'product' | 'update';
}

export function buildBadges(article: ProductUpdate): Badge[] {
  const badges: Badge[] = [];

  // New first, then Coming soon
  if (article.updateCategories.includes('New')) {
    badges.push({ category: 'New', type: 'update' });
  }
  if (article.updateCategories.includes('Coming soon')) {
    badges.push({ category: 'Coming soon', type: 'update' });
  }

  // Product categories
  for (const category of article.productCategories) {
    badges.push({ category, type: 'product' });
  }

  // Remaining update categories
  for (const category of article.updateCategories) {
    if (category !== 'New' && category !== 'Coming soon') {
      badges.push({ category, type: 'update' });
    }
  }

  return badges;
}
